export default {
  name: 'validation-observer-event-emitter',
  render (h) {
    if (this.$slots.default?.length === 1) return this.$slots.default;
    return h('div', this.$slots.default);
  },
  props: {
    observer: {
      type: Object,
      required: true,
    },
  },
  watch: {
    observer: {
      handler (val, prevVal) {
        if (JSON.stringify(val) === JSON.stringify(prevVal)) return;
        this.$emit('update', val);
      },
      deep: true,
      immediate: true,
    },
  },
};
